// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","separator":"Footer_separator__n6RnS","agbLink":"Footer_agbLink__+ekcB"};